import ExtraCreditConfigFile from "../Datasets/extra_credit_config_file";


export const getLinkNames = (levelNbr) => {
    let exerciseArr = ExtraCreditConfigFile.exercises;
    let linkNameArr = [];
    let challengeArr = exerciseArr.filter(item => item.level === levelNbr);
    for (let i=0; i<challengeArr.length; i++){
         const linkName = challengeArr[i].titleText + " (" + challengeArr[i].type + ")";
         linkNameArr.push(linkName);
    }
    return linkNameArr;

}
export default getLinkNames;